export const ROUTES = {
  home: '/overview',
  login: '/login',
  otpLogin: '/login/verify',
  autoLogout: '/auto-logout',
  signup: '/signup',
  identityVerification: '/verification/identity',
  phoneNumberVerification: '/verification/phone-number',
  scriveConnected: '/connected/scrive',
  montoConnected: '/connected/monto',
  codatConnected: '/connected/codat',
  googleLoginRedirect: '/users/google/login/callback',
  userEmailConfirmation: '/api/users/confirmation',
  addCompany: '/company/add-company',
  onboarding: '/onboarding',
  orders: '/orders',
  ordersPayables: '/orders/payables',
  ordersReceivables: '/orders/receivables',
  invoices: '/invoices',
  counterParties: '/counter-parties',
  counterPartiesCustomers: '/counter-parties/customers',
  counterPartiesSuppliers: '/counter-parties/suppliers',
  wallet: '/wallet',
  walletPrimary: '/wallet/primary',
  walletPrimaryDetails: '/wallet/primary/details',
  walletPrimaryHeldBalance: '/wallet/primary/held-balance',
  walletPrimaryRequests: '/wallet/primary/requests',
  walletPrimaryTransactions: '/wallet/primary/transactions',
  walletAccounts: '/wallet/primary/accounts',
  walletPayouts: '/wallet/payouts',
  company: '/company',
  help: '/help',
  profile: '/profile/details',
  overview: '/overview',
  forgotPassword: '/password/forgot',
  resetPassword: '/password/reset',
  verifyEmail: '/email/verify',
  acceptInvitationEmail: '/email/accept-invitation',
  confirmEmail: '/confirm-email',
  maintenance: '/maintenance',
  companyInvitations: '/company/invitations',
};
export const COMPANY_FLOWS_ROUTES = {
  financialDocuments: '/company?flow=financial_documents',
  erp: '/company?flow=erp',
  connectBank: '/company?flow=connect_bank',
  uploadBankStatement: '/company?flow=upload_bank_statement',
  renewKyc: '/company?flow=renew_kyc',
  companyDocuments: '/company?tab=documents',
};

export const HIDDEN_NAVIGATION_ROUTES: Readonly<RegExp[]> = [
  /\/orders\/\d+$/,
  /\/orders\/receivables\/\d+$/,
  /\/orders\/payables\/\d+$/,
  /\/company\/add-company/,
  /\/verification\/identity/,
  /\/verification\/phone-number/,
  /\/connected/,
  /\/confirm-email/,
  /\/company\/invitations/,
];

export const UNAUTHENTICATED_ROUTES: Readonly<string[]> = [
  ROUTES.login,
  ROUTES.otpLogin,
  ROUTES.autoLogout,
  ROUTES.signup,
  ROUTES.forgotPassword,
  ROUTES.resetPassword,
  ROUTES.verifyEmail,
  ROUTES.acceptInvitationEmail,
  ROUTES.maintenance,
];
